import React from "react";
import DownloadButtons from "../download-buttons/downloadButtons";

class HeroSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="ptb-100 overflow-hidden" image-overlay="10">
          <div
            className="hero-bottom-shape-two"
            style={{
              backgroundImage: "url(img/hero-bottom-shape-2.png)",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "bottom center",
            }}
          ></div>
          <div className="container">
            <div className="row align-items-center justify-content-lg-between justify-content-md-center justify-content-sm-center pt-5">
              <div className="col-md-12 col-lg-6 order-2 order-lg-1 order-sm-2">
                <div className="hero-slider-content text-white py-5">
                  <h2 className="text-white mb-0">
                    Anthem Remote App
                    {/* <br></br>Early Access / Public Beta */}
                  </h2>
                  <div className="lead">
                    <p className="pt-3">
                      Gain unprecedented command over your network-enabled
                      Anthem A/V Receiver, Processor or Pre-amplifier.
                    </p>
                    The Anthem Remote App uses a Wifi connection to simplify the
                    configuration of supported Anthem devices. App-based
                    controls include volume level, muting, input selection,
                    power, listening modes, bass, treble, level trims, menu
                    navigation, and Anthem Room Correction (ARC) control.
                  </div>
                  <DownloadButtons center={false} />
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-5 order-1 order-lg-2 order-sm-1">
                <div className="img-wrap">
                  <img
                    src="img/phone-hero-resized.png"
                    alt="app"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default HeroSection;
